export const socialStepEditorMenuType = {
  TextFields: 'TextFields',
  Media: 'Media',
  Socials: 'Socials',
  AdvancedMode: 'AdvancedMode',
};
